import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { TextArea } from 'semantic-ui-react';

import OutsideHandler from 'components/common/OutsideHandler';

import './CommerceTextArea.css';

function CommerceTextArea(props) {
  const {
    label,
    rows,
    placeholder,
    initialValue,
    maxLength,
    parameter,
    patchFunction,
    linkId,
  } = props;

  const [currentValue, setCurrentValue] = useState(null);
  const [prevValue, setPrevValue] = useState(null);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    if (initialValue) {
      setCurrentValue(initialValue);
      setPrevValue(initialValue);
    }
  }, []);

  useEffect(() => {
    if (initialValue) {
      setCurrentValue(initialValue);
      setPrevValue(initialValue);
    }
  }, [initialValue]);

  const onChangeValue = () => {
    const form = new FormData();
    form.append(parameter, currentValue);
    patchFunction(linkId, form);
  };

  const handleClickOutside = () => {
    if (currentValue !== prevValue && !isError) {
      onChangeValue();
      setPrevValue(currentValue);
    }
  };

  return (
    <div className="commerce-textarea__component">
      {label && <div className="label">{label}</div>}
      <OutsideHandler handleClickOutside={handleClickOutside}>
        <TextArea
          rows={rows}
          placeholder={placeholder}
          value={currentValue}
          onChange={e => {
            if (
              maxLength &&
              maxLength > 0 &&
              e.target.value.length > maxLength
            ) {
              setIsError(true);
            } else {
              setIsError(false);
            }
            setCurrentValue(e.target.value);
          }}
        />
      </OutsideHandler>
      {maxLength && isError ?
        <div className="words-counter error">
          You can only write {maxLength} characters
        </div>
        :
        <div className="words-counter">
          {maxLength - (currentValue && currentValue.length)} characters left
        </div>
      }   
    </div>
  );
}

CommerceTextArea.propTypes = {
  patchFunction: PropTypes.func.isRequired,
  rows: PropTypes.number,
  placeholder: PropTypes.string,
  initialValue: PropTypes.string,
  label: PropTypes.string,
  maxLength: PropTypes.number,
  parameter: PropTypes.string.isRequired,
  linkId: PropTypes.number.isRequired,
};

CommerceTextArea.defaultProps = {
  rows: null,
  placeholder: null,
  initialValue: null,
  label: null,
  maxLength: null,
};

export default CommerceTextArea;
